var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.118 9.901 15.64 1.034c-.578-.54-.867-.81-1.196-.913a1.5 1.5 0 0 0-.889 0c-.328.102-.617.372-1.195.913L2.882 9.9C1.547 11.15.879 11.774.812 12.311a1.5 1.5 0 0 0 .53 1.344C1.758 14 2.672 14 4.5 14v7.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.31C6.78 26 7.631 26 9.333 26c.851 0 1.277 0 1.598-.164a1.5 1.5 0 0 0 .655-.655c.164-.321.164-.741.164-1.581v-5.35a2.25 2.25 0 0 1 4.5 0v5.35c0 .84 0 1.26.163 1.58a1.5 1.5 0 0 0 .656.656c.32.164.747.164 1.598.164 1.702 0 2.553 0 3.195-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V14c1.828 0 2.742 0 3.158-.345a1.5 1.5 0 0 0 .53-1.345c-.067-.536-.735-1.16-2.07-2.409Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome28);
export default __webpack_public_path__ + "static/media/home_28.ddb19d41.svg";
export { ForwardRef as ReactComponent };